'use client';

import React from 'react';

/** Spacing steps shown in foundations + docs */
export const FOUNDATION_SPACE_TOKENS = [
  '--space-2',
  '--space-3',
  '--space-4',
  '--space-5',
  '--space-6',
] as const;

/** [CSS custom property name, resolved value for borderRadius] */
export const FOUNDATION_RADIUS_PAIRS = [
  ['--radius-sm', 'var(--radius-sm)'],
  ['--radius-md', 'var(--radius-md)'],
  ['--radius-lg', 'var(--radius-lg)'],
  ['--radius-pill', 'var(--radius-pill)'],
] as const;

export const FOUNDATION_SHADOW_TOKENS = [
  '--shadow-sm',
  '--shadow-md',
  '--shadow-lg',
  '--shadow-xlg',
] as const;

export function SpacingScaleDemo() {
  return (
    <ul className='ft-spacing'>
      {FOUNDATION_SPACE_TOKENS.map((token) => (
        <li key={token} className='row'>
          <span className='token'>{token}</span>
          <span
            className='swatch'
            style={{
              width: `var(${token})`,
              minWidth: '0.4rem',
            }}
            aria-hidden
          />
        </li>
      ))}
    </ul>
  );
}

export function RadiusScaleDemo() {
  return (
    <div className='ft-radius'>
      {FOUNDATION_RADIUS_PAIRS.map(([label, radius]) => (
        <div key={label} className='item'>
          <div className='demo' style={{ borderRadius: radius }} />
          <div className='token'>{label}</div>
        </div>
      ))}
    </div>
  );
}

export function ShadowTokensDemo() {
  return (
    <div className='ft-shadow'>
      {FOUNDATION_SHADOW_TOKENS.map((token) => (
        <div
          key={token}
          className='tile'
          style={{ boxShadow: `var(${token})` }}
        >
          <span className='token'>{token}</span>
        </div>
      ))}
    </div>
  );
}
